/*入驻资料相关路由*/
export default{
  path: '/supplier/enterData',
  component: resolve=>require(['@/views/main.vue'],resolve),
  children:[
    {path:'',component:resolve=>require(['@/views/enter_data/index.vue'],resolve)}
  ]
}
